module.exports = __webpack_public_path__ + "static/media/vodafone.b55e7ce0.svg";